// src/contexts/ShopPreferences.context.jsx

'use client';

import { createContext, useState, useEffect, useContext } from 'react';

// const euroCurrencyLocales = ['fr', 'it', 'es'];


// Create the context
const ShopPreferencesContext = createContext({
  currency: 'EUR',
  setCurrency: () => {},
  shippingLocation: 'US',
  setShippingLocation: () => {},
  unitSystem: '',
  setUnitSystem: () => {},
  // cookieConsent: undefined,
  // setCookieConsent: () => {},
});

// Create a provider component
export function ShopPreferencesProvider({ children, locale }) {

  // Initialize state with consistent defaults
  // const defaultCurrency = euroCurrencyLocales.includes(locale) ? 'EUR' : 'USD';
  const defaultCurrency = 'EUR';
  const defaultUnits = locale === 'en' ? 'USC' : 'SI';

  // Initialize with default values first
  const [currency, setCurrency] = useState(defaultCurrency);
  const [shippingLocation, setShippingLocation] = useState('US');
  const [unitSystem, setUnitSystem] = useState(defaultUnits);
  // const [cookieConsent, setCookieConsent] = useState(undefined);

  // Add state to track if component is mounted
  const [isMounted, setIsMounted] = useState(false);

  // Only run localStorage operations after component is mounted on client
  useEffect(() => {
    setIsMounted(true);

    // Now it's safe to access localStorage
    const storedCurrency = localStorage.getItem('currency');
    if (storedCurrency) {
      setCurrency('EUR'); // TODO: Undo this when we return to multi-currency support, and put storedCurrency back
    } else {
      localStorage.setItem('currency', defaultCurrency);
    }

    const storedLocation = localStorage.getItem('shippingLocation');
    if (storedLocation) {
      setShippingLocation(storedLocation);
    } else {
      localStorage.setItem('shippingLocation', 'US');
    }

    const storedUnits = localStorage.getItem('unitSystem');
    if (storedUnits) {
      setUnitSystem(storedUnits);
    } else {
      localStorage.setItem('unitSystem', defaultUnits);
    }

    // const storedCookieConsent = localStorage.getItem('cookieConsent');
    // if (storedCookieConsent) {
    //   setCookieConsent(storedCookieConsent === 'true');
    // }
  }, [defaultCurrency, defaultUnits]);

  // Only update localStorage when both the component is mounted and values change
  useEffect(() => {
    if (isMounted) {
      localStorage.setItem('currency', currency);
    }
  }, [currency, isMounted]);

  useEffect(() => {
    if (isMounted) {
      localStorage.setItem('shippingLocation', shippingLocation);
    }
  }, [shippingLocation, isMounted]);

  useEffect(() => {
    if (isMounted) {
      localStorage.setItem('unitSystem', unitSystem);
    }
  }, [unitSystem, isMounted]);

  // useEffect(() => {
  //   if (isMounted && cookieConsent !== undefined) {
  //     localStorage.setItem('cookieConsent', cookieConsent);
  //   }
  // }, [cookieConsent, isMounted]);

  // Create an object with the state and setter functions
  const value = {
    currency,
    setCurrency,
    shippingLocation,
    setShippingLocation,
    unitSystem,
    setUnitSystem,
    // cookieConsent,
    // setCookieConsent,
  };

  return (
    <ShopPreferencesContext.Provider value={value}>
      {children}
    </ShopPreferencesContext.Provider>
  );
}


export const usePreferences = () => useContext(ShopPreferencesContext);
